export default "assets/images/icons/instagram-0abf99ad.svg";